module.exports = __webpack_public_path__ + "static/img/s7.af72c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s7.png
// module id = ckM7
// module chunks = 1